import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, TextField, Typography } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { ORGANIZATION_SERVER } from '../../Config';
import axios from 'axios';

const DeleteProjectDialog = (props) => {
  const [deleteBtn, setDeleteBtn] = useState(true);
  const [inputText, setInputText] = useState('');

  const projectDelete = () => {
    axios
      .put(`${process.env.REACT_APP_SERVER}${ORGANIZATION_SERVER}/project`, {
        projectId: props.projectId,
      })
      .then((res) => {
        props.projectLoad();
      });
    props.handleClose();
  };

  return (
    <Dialog open={props.open} onClose={props.handleClose} maxWidth="sm" fullWidth>
      <DialogTitle color="error" fontWeight="bold">
        프로젝트 삭제
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          minWidth: '440px',
          minHeight: '140px',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '1.1rem' }}>
          <u>
            <b>{`"${props.deleteText}"`}</b>
          </u>
          {' 프로젝트를 삭제하려면,'}
          <br />
          {' 프로젝트 이름을'}
          <u>
            <b>{`"${props.deleteText}"`}</b>
          </u>
          {' 로 정확히 입력하세요.'}
        </Typography>

        <TextField
          autoFocus
          variant="outlined"
          color="warning"
          fullWidth
          placeholder="프로젝트 이름을 입력하세요"
          value={inputText}
          onChange={(e) => {
            const newVal = e.target.value;
            setDeleteBtn(newVal !== props.deleteText);
            setInputText(newVal);
          }}
          error={!!inputText && inputText !== props.deleteText}
          helperText={
            !!inputText && inputText !== props.deleteText ? '입력값이 프로젝트 이름과 일치하지 않습니다.' : ' '
          }
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" color="inherit" onClick={props.handleClose}>
          취소
        </Button>
        <Button
          disabled={deleteBtn}
          variant="contained"
          color="error"
          onClick={projectDelete}
          startIcon={<DeleteForeverIcon />}
        >
          삭제
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteProjectDialog;
